/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageContent } from '../../models/image-content';

export interface ApiMasterImageContentGetAllGet$Params {
}

export function apiMasterImageContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterImageContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterImageContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ImageContent>>;
    })
  );
}

apiMasterImageContentGetAllGet.PATH = '/api/Master/ImageContent/GetAll';
